/**
 * ResearchLab - Unified product research and discovery workspace
 * Combines Search CJ, Match Product, and Discovery into single view
 */

import { ResearchView } from './ResearchView';

export function ResearchLab() {
  return <ResearchView />;
}

export default ResearchLab;
